// pagesTexts/index.ts
import DASHBOARD from "./DASHBOARD.json";
import PATIENTS from "./PATIENTS.json";
import VISITS from "./VISITS.json";
import PAYMENTS from "./PAYMENTS.json";
import APPOINTMENTS from "./APPOINTMENTS.json";
import PROFILE from "./PROFILE.json";
import MEDICATIONS from "./MEDICATIONS.json";
import TEAM from "./TEAM.json";
import STATISTICS from "./STATISTICS.json";
import APPEARANCE from "./APPEARANCE.json";
import WAITING_ROOM from "./WAITING_ROOM.json";
import RECEPTION from "./RECEPTION.json";
import COMPONENTS from "./COMPONENTS.json";
import BREADCRUMBS from "./BREADCRUMBS.json";
import SUBSCRIPTION from "./SUBSCRIPTION.json";
import ROLES from "./ROLES.json";
import MY_REQUESTS from "./MY_REQUESTS.json";
import NAVIGATION from "../navigation/NAVIGATION.json";
import TABLE from "./TABLE.json";
import TOOLS from "./TOOLS.json";
import PERMISSIONS from "./PERMISSIONS.json";
import UI from "./UI.json";
import AI from "./AI.json";

export const PAGES_TEXTS: Record<string, any> = {
  DASHBOARD,
  PATIENTS,
  VISITS,
  PAYMENTS,
  APPOINTMENTS,
  PROFILE,
  MEDICATIONS,
  TEAM,
  STATISTICS,
  APPEARANCE,
  WAITING_ROOM,
  RECEPTION,
  COMPONENTS,
  BREADCRUMBS,
  SUBSCRIPTION,
  ROLES,
  MY_REQUESTS,
  NAVIGATION,
  TABLE,
  TOOLS,
  PERMISSIONS,
  UI,
  AI,
};
